import { StreamingCameraType } from "lib/types";
import { ReactNode, createContext, useState } from "react";

type StreamingContextType = {
  streamingCameras: StreamingCameraType[];
  setStreamingCameras: (newState: StreamingCameraType[]) => void;

  selectedCamera: StreamingCameraType;
  setSelectedCamera: (newState: StreamingCameraType) => void;
  audioMuted: boolean;
  setAudioMuted: (newState: boolean) => void;
  showPtz: boolean;
  setShowPtz: (newState: boolean) => void;
  streamId: number;
  setStreamId: (newState: number) => void;
};

const initialStreamingCameras: StreamingCameraType[] = [];

const initialValue = {
  streamingCameras: initialStreamingCameras,
  setStreamingCameras: () => {},
  selectedCamera: null,
  setSelectedCamera: () => {},
  audioMuted: true,
  setAudioMuted: () => {},
  showPtz: false,
  setShowPtz: () => {},
  streamId: 1, //default to SD (streamId=0 is HD, streamId=1 is SD)
  setStreamId: () => {},
};

export const StreamingContext =
  createContext<StreamingContextType>(initialValue);

export default function StreamingProvider({
  children,
}: {
  children?: ReactNode;
}) {
  const [streamingCameras, setStreamingCameras] = useState(
    initialValue.streamingCameras,
  );
  const [selectedCamera, setSelectedCamera] = useState(
    initialValue.selectedCamera,
  );

  const [audioMuted, setAudioMuted] = useState(initialValue.audioMuted);

  const [showPtz, setShowPtz] = useState(initialValue.showPtz);
  const [streamId, setStreamId] = useState(initialValue.streamId);

  // if (streamingCameras.length > 1 && streamId === 0) {
  //     setStreamId(1);
  // }

  return (
    <StreamingContext.Provider
      value={{
        streamingCameras,
        setStreamingCameras,
        selectedCamera,
        setSelectedCamera,
        audioMuted,
        setAudioMuted,
        showPtz,
        setShowPtz,
        streamId,
        setStreamId,
      }}
    >
      {children}
    </StreamingContext.Provider>
  );
}
